import { Component, input, output } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

/**
 * The one place a list renders its **empty** and **error** states. Loading
 * stays on the table via `[nzLoading]`. Drop this into an `nzNoResult`
 * template for empty, or render it in place of the table on error.
 */
@Component({
  selector: 'app-table-states',
  standalone: true,
  imports: [NzButtonModule, NzIconModule],
  templateUrl: './table-states.component.html',
  styleUrl: './table-states.component.scss',
})
export class TableStatesComponent {
  error = input<unknown>(null);
  errorTitle = input('Couldn’t load the list');
  emptyTitle = input('Nothing here yet');
  emptyHint = input('');
  readonly retry = output<void>();
}
